import {
  ControlRow,
  ControlButton,
  ControlIcon,
  ControlLabel,
} from './chartControlStyles';

const DRILL_IN_HINT = 'click a bar or point on the chart to drill in';

const ChartDetailControls = ({ canDrillOut, onDrillOut }) => (
  <ControlRow>
    <ControlButton
      type='button'
      aria-label='drill out'
      title={DRILL_IN_HINT}
      onClick={onDrillOut}
      disabled={!canDrillOut}
    >
      <ControlIcon src='/images/zoomButtonMinus.svg' alt='' />
    </ControlButton>
    <ControlLabel>detail</ControlLabel>
  </ControlRow>
);

export default ChartDetailControls;
